import { RouteModule } from '#/horizon/components/RouteModule';

import { WydPageLoadable } from './WydPageLoadable';

export default function WydHorizonRoute() {
  return (
    <RouteModule title="WYD Interest Form">
      <WydPageLoadable />
    </RouteModule>
  );
}
